import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    me: {}
  },
  mutations: {
    SET_ME (store, val) {
      store.me = val
    }
  },
  getters: {
    getMe: (store) => {
      return store.me
    }
  },
  actions: {
    setMe ({commit, dispatch}) {
      return axios
      .get(`/auth/me`)
      .then((response) => {
        commit('SET_ME', response.data)
        return response.data
      })
    },
    updateMe ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/auth/me`, data)
      .then((response) => {
        commit('SET_ME', response.data)
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    },
    passwordRedefined ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/auth/me/password-redefined`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    },
    emailRdefine ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/auth/me/email-redefine`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Me.js